import { isObject, isString } from "@mcwd/typescript-type-guards";
import { SiteLocale, type CountryLocale } from "../../../types-and-definitions/locale-defs/Locales.js";
import { GeoLocation } from "../GeoLocation.js";

export function getSiteLangFromGeoLocation ()
{
  const geoLocation = GeoLocation.value;
  if (isObject(geoLocation) && isString(geoLocation.countryCode) && geoLocation.countryCode.trim() !== "")
  {
    const sLocale = SiteLocale.getByCountryLocale(geoLocation.countryCode as CountryLocale);
    if (isObject(sLocale))
    {
      return sLocale.LanguageCountryLocale;
    }
  }
  return null;
}
